import React, { useEffect, useState, useCallback } from "react";
import { useParams, useLocation } from "react-router-dom";
import API from "../api";
import Layout from "../components/Layout";

const CustomerHistory = () => {
    const { id } = useParams();
    const location = useLocation();
    const customerInfo = location.state?.customer || {};

    const [orders, setOrders] = useState([]);

    const fetchHistory = useCallback(async () => {
        try {
            const res = await API.get(`/orders/customer/${id}`);
            setOrders(res.data || []);
        } catch (err) {
            console.log(err);
        }
    }, [id]);

    useEffect(() => {
        fetchHistory();
    }, [fetchHistory]);

    return (
        <Layout>
            <div className="header-row">
                <h2>Customer History</h2>
            </div>

            <div className="table-section" style={{ marginBottom: "20px", padding: "15px" }}>
                <p><b>Name:</b> {customerInfo.name}</p>
                <p><b>Phone:</b> {customerInfo.phone}</p>
                <p><b>Address:</b> {customerInfo.address}</p>
                <p><b>State:</b> {customerInfo.state}</p>
            </div>

            <div className="table-section">
                <div className="table-responsive">
                    <table>
                        <thead>
                            <tr>
                                <th>S/N</th>
                                <th>Order ID</th>
                                <th>Invoice No</th>
                                <th>Date</th>
                                <th>Total</th>
                                <th>Paid</th>
                                <th>Total Due</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.length > 0 ? (
                                orders.map((o, i) => (
                                    <tr key={o._id}>
                                        <td>{i + 1}</td>
                                        <td>{o.orderId}</td>
                                        <td>{o.invoiceNo}</td>
                                        <td>{new Date(o.createdAt).toLocaleDateString("en-IN")}</td>
                                        <td>₹{o.finalTotal}</td>
                                        <td>₹{o.amountTendered}</td>
                                        <td style={{ color: o.dueAmount > 0 ? "red" : "green" }}>
                                            ₹{o.dueAmount}
                                        </td>
                                        {/* <td>{o.showDue === "active" ? "Due Active" : "Paid"}</td> */}
                                        <td>{o.dueAmount > 0 ? "Due Pending" : "Paid"}</td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center" }}>
                                        No Orders Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
};

export default CustomerHistory;